"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var initialState = {
  addons: {
    active: [],
    cancelled: []
  },
  isFetchingData: false,
  cancelAddon: {},
  updateAddons: false,
  addonIconsList: [],
  defaultAddonIcon: '',
  showPopup: false,
  currentMode: null,
  eligibleAddons: {
    addons: {},
    isLoading: false,
    error: null
  },
  // TODO: Remove after integration
  isStaticAddons: false,
  activeAddons: {
    unmappedOptions: [],
    mappedOptions: [],
    isLoading: true,
    error: null
  },
  purchaseFlowError: null
};
var _default = initialState;
exports.default = _default;